import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FiMenu, FiX } from "react-icons/fi";

const Navbar = () => {
  const { t } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow z-10">
      <div className="flex items-center justify-between py-4 max-w-7xl mx-auto px-4 sm:px-0">
        <Link to="/" onClick={() => setMenuOpen(false)}>
          <img
            src="/assets/images/logo.png"
            alt={t("navbar.logoAlt")}
            className="h-10 w-auto"
          />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex space-x-6 items-center">
          <Link to="/" className="hover:text-primary">{t("navbar.home")}</Link>
          <Link to="/about" className="hover:text-primary">{t("navbar.about")}</Link>
          <Link to="/services" className="hover:text-primary">{t("navbar.services")}</Link>
          <Link to="/products" className="hover:text-primary">{t("navbar.products")}</Link>
          <Link to="/reseller" className="hover:text-primary">{t("navbar.reseller")}</Link>
          <Link to="/promotions" className="hover:text-primary">{t("navbar.promotions")}</Link>
          <Link to="/contact" className="hover:text-primary">{t("navbar.contact")}</Link>
        </nav>

        {/* Mobile Nav Toggle */}
        <button
          className="md:hidden text-primary"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
        </button>
      </div>

      {/* Mobile Dropdown */}
      {menuOpen && (
        <div className="md:hidden bg-white px-8 pt-6 pb-6 flex flex-col space-y-3 text-left">
          <Link to="/" className="hover:text-primary" onClick={() => setMenuOpen(false)}>
            {t("navbar.home")}
          </Link>
          <Link to="/about" className="hover:text-primary" onClick={() => setMenuOpen(false)}>
            {t("navbar.about")}
          </Link>
          <Link to="/services" className="hover:text-primary" onClick={() => setMenuOpen(false)}>
            {t("navbar.services")}
          </Link>
          <Link to="/products" className="hover:text-primary" onClick={() => setMenuOpen(false)}>
            {t("navbar.products")}
          </Link>
          <Link to="/reseller" className="hover:text-primary" onClick={() => setMenuOpen(false)}>
            {t("navbar.reseller")}
          </Link>
          <Link to="/promotions" className="hover:text-primary" onClick={() => setMenuOpen(false)}>
            {t("navbar.promotions")}
          </Link>
          <Link to="/contact" className="hover:text-primary" onClick={() => setMenuOpen(false)}>
            {t("navbar.contact")}
          </Link>
        </div>
      )}
    </header>
  );
};

export default Navbar;
